import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing(1.5)};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
`;
